import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Locomotive from './Locomotive';
import TrainInfo from './TrainInfo';
import CarInfo from './CarInfo';

const ValeView = (props) => {
  const [data, setData] = useState({ trains: [] });

  return (<div className="new-fleet-info">
    {data && data.trains && data.trains.map( (train, index) =>
      <div key={index + train.trainId} className="new-fleet-info__train">
        <TrainInfo props = {props} train={train} />
        <div style={{paddingLeft: "24px", paddingRight: "24px"}}>
          <ul className="new-fleet-info__train__cars--list">
            <Locomotive name="Locom" />
            {train.carActiveEventStatuses && train.carActiveEventStatuses.map(car => <CarInfo key={car.carNumber} consist={train.consist} car={car} />)}
          </ul>
        </div>
        <div className="new-fleet-info__train__info">
          <div className="new-fleet-info__train__info__header">
            <div className="new-fleet-info__train__info__header--block">
              <span>Train No.</span>
            </div>
            <div className="new-fleet-info__train__info__header--block">
              <span>Special Car</span>
            </div>
            <div className="new-fleet-info__train__info__header--block">
              <span>Speed</span>
            </div>
            <div className="new-fleet-info__train__info__header--block-xl">
              <span>Previous station</span>
            </div>
            <div className="new-fleet-info__train__info__header--block-xl">
              <span>Next station</span>
            </div>
            <div className="new-fleet-info__train__info__header--block-xl">
              <span>Destination</span>
            </div>
            <div className="new-fleet-info__train__info__header--block-xl">
              <span>Last data received</span>
            </div>
          </div>
          <div className="new-fleet-info__train__info__content">
            <div className="new-fleet-info__train__info__content--block">
              <span>{train.status.train}</span>
            </div>
            <div className="new-fleet-info__train__info__content--block">
              <span>{train.status.trainId}</span>
            </div>
            <div className="new-fleet-info__train__info__content--block">
              <span>{train.status.speed} km/h</span>
            </div>
            <div className="new-fleet-info__train__info__content--block-xl">
              <span>{train.status.stationFull}</span>
            </div>
            <div className="new-fleet-info__train__info__content--block-xl">
              <span>{train.status.nextStationFull}</span>
            </div>
            <div className="new-fleet-info__train__info__content--block-xl">
              <span>{train.status.destinationStationFull}</span>
            </div>
            <div className="new-fleet-info__train__info__content--block-xl">
              <span>{train.status.dataReceived}</span>
            </div>
          </div>
        </div>
      </div>)}
  </div>
  )
};
ValeView.propTypes = {
  onTrainSelect: PropTypes.func,
  dataLoading: PropTypes.bool
};
export default ValeView